import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '@/shared/i18n/use-language'
import { redirectIfPublicPageHidden } from '@/shared/lib/hidden-public-pages'

export const Route = createFileRoute('/resources')({
  // English resources live at the root; hidden, they fall back to /en.
  beforeLoad: () => redirectIfPublicPageHidden('resources', 'en'),
  component: ResourcesLayout,
  staticData: { layout: 'public' },
})

function ResourcesLayout() {
  const { i18n } = useTranslation()
  const { language, setLanguage } = useLanguage()

  useEffect(() => {
    document.documentElement.lang = 'en'
    if (i18n.language !== 'en') void i18n.changeLanguage('en')
    if (language !== 'en') setLanguage('en')
  }, [i18n, language, setLanguage])

  return <Outlet />
}
